export enum LIST_WIDTH {
  CONTENT = 'min-content',
  AUTO = 'auto',
}
export enum LIST_MODE {
  TABLE = 'table',
  GRID = 'grid',
}
